var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnMobileNavEtc = function SvgIcnMobileNavEtc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.39V5.985C19.5 4.9275 19.02 4.5 17.8275 4.5H14.7975C13.605 4.5 13.125 4.9275 13.125 5.985V9.3825C13.125 10.4475 13.605 10.8675 14.7975 10.8675H17.8275C19.02 10.875 19.5 10.4475 19.5 9.39Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.8275V14.7975C19.5 13.605 19.02 13.125 17.8275 13.125H14.7975C13.605 13.125 13.125 13.605 13.125 14.7975V17.8275C13.125 19.02 13.605 19.5 14.7975 19.5H17.8275C19.02 19.5 19.5 19.02 19.5 17.8275Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8749 9.39V5.985C10.8749 4.9275 10.3949 4.5 9.20238 4.5H6.17238C4.97988 4.5 4.49988 4.9275 4.49988 5.985V9.3825C4.49988 10.4475 4.97988 10.8675 6.17238 10.8675H9.20238C10.3949 10.875 10.8749 10.4475 10.8749 9.39Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8749 17.8275V14.7975C10.8749 13.605 10.3949 13.125 9.20238 13.125H6.17238C4.97988 13.125 4.49988 13.605 4.49988 14.7975V17.8275C4.49988 19.02 4.97988 19.5 6.17238 19.5H9.20238C10.3949 19.5 10.8749 19.02 10.8749 17.8275Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMobileNavEtc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_mobile_nav_etc.32d4d87e.svg";
export { ForwardRef as ReactComponent };